'use client';

import { motion } from 'motion/react';
import Image from 'next/image';

export default function Hero() {
  return (
    <section className="relative bg-[#0a0a0a] px-6 pt-32 pb-20 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8 items-center">
          <div className="flex flex-col justify-center z-10">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="mb-8 flex w-fit rounded border border-zinc-800 bg-zinc-900/50 px-3 py-1 text-[10px] font-bold tracking-widest text-[#b4ff00]"
            >
              PLATFORM STRUCTURE
            </motion.div>

            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mb-6 text-5xl font-black leading-[1.1] tracking-tighter text-white md:text-6xl lg:text-7xl"
            >
              One connected <br />
              hierarchy for <span className="text-[#b4ff00]">modern <br /> competition.</span>
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.2 }}
              className="mb-10 max-w-md text-lg text-zinc-400"
            >
             <strong>Build a complete competition ecosystem.</strong> From global headquarters to the individual athlete, <strong>manage every touchpoint</strong> with professional-grade architecture with <strong>your own branding.</strong>
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
              className="flex flex-wrap gap-4"
            >
              <button className="flex items-center gap-2 rounded-sm bg-[#b4ff00] px-8 py-4 text-sm font-bold text-black transition-transform hover:scale-105">
                Request a Demo <span>→</span>
              </button>
              <button className="rounded-sm border border-zinc-700 bg-zinc-900/50 px-8 py-4 text-sm font-bold text-white transition-colors hover:bg-zinc-800">
                Explore the System
              </button>
            </motion.div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="relative hidden lg:block h-[500px] w-full rounded-2xl overflow-hidden border border-zinc-800/50"
          >
            <Image
              src="https://images.unsplash.com/photo-1522778119026-d647f0596c20?q=80&w=1000&auto=format&fit=crop"
              alt="Football Stadium"
              fill
              className="object-cover opacity-60 grayscale"
              priority
              referrerPolicy="no-referrer"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-[#0a0a0a] via-transparent to-transparent" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
